export default "__VITE_ASSET__DiZZAwzY__"